// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 文档中心
import docCenter from '@/views/docCenter/docCenter';
// 文档中心-搜索
import docSearch from '@/views/docCenter/docSearch';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
// 系统首页
import Dashboard from '@/views/dashboard/Dashboard';
// API类型管理
import typeDocument from '@/views/Document/typeDocument';
// 开发文档管理
import developDocument from '@/views/Document/developDocument';

/**
 * 权限管理
 */
// 权限-账号管理
import account from '@/views/power/account';
// 权限-角色管理
import role from '@/views/power/role';

// 启用路由
Vue.use(Router);

// 导出路由

const routes = [{
  path: '/',
  name: '文档中心',
  component: docCenter,
  hidden: true,
  meta: {
    requireAuth: false
  }
}, {
  path: '/docCenter/docCenter',
  name: '文档中心',
  component: docCenter,
  hidden: true,
  meta: {
    requireAuth: false
  }
}, {
  path: '/docCenter/docSearch',
  name: '搜索结果',
  component: docSearch,
  hidden: true,
  meta: {
    requireAuth: false
  }
}, {
  path: '/login',
  name: '登录',
  component: login,
  hidden: true,
  meta: {
    requireAuth: false
  }
}, {
  path: '/index',
  name: '首页',
  component: index,
  iconCls: 'el-icon-tickets',
  children: [{
    path: '/dashboard/Dashboard',
    name: '首页',
    component: Dashboard,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Document/typeDocument',
    name: 'API类型管理',
    component: typeDocument,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Document/developDocument',
    name: '开发文档管理',
    component: developDocument,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/power/account',
    name: '账号管理',
    component: account,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/power/role',
    name: '角色管理',
    component: role,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },]
}]
const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   // 这个语句用来解决报错
//   // 调用原来的push函数，并捕获异常
//   return routerPush.call(this, location).catch(error=> error)
// }
export default router



// WEBPACK FOOTER //
// ./src/router/index.js